import React, { useState } from 'react'
import Wrapper from '../helpers/Wrapper'
import SectionHead from '../components/SectionHead'
import Input from '../components/Form Elements/Input'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import Button from '../ui/Button'
import LinkButton from '../ui/LinkButton'
import { useNavigate } from 'react-router-dom'
import LogError from '../components/LogError'
import AnimatePage from '../components/AnimatePage'
import { ChangePageTitle } from '../helpers/ChangeTitle'
import Select from '../components/Form Elements/Select'
import { countriesData } from '../helpers/config'

function Register() {
    ChangePageTitle("Create Account")
    const [data, setData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        phone: "",
        code: ""
    })

    const navigate = useNavigate()

    // HandleInputChange

    const handleInput = (e) => {
        const { id, value } = e.target
        setData({ ...data, [id]: value })
    }

    const { mutate, isPending, isSuccess, error } = useMutation({
        mutationFn: async (formData) => {
            return apiClient.post('/auth/register', formData)
        }
    })

    // Login 
    const handleLogin = () => {
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })
        mutate(formData)
    }

    if (isSuccess) {
        navigate('/account/login')
    }

    return (
        <AnimatePage>
            <div className='w-full relative mt-16'>
                <Wrapper>
                    <SectionHead
                        title="Register"
                        description="Create an account to enjoy exclusive deals, faster checkout, 
                    and easy order tracking!"
                    />


                    {/* Log Error */}
                    <LogError error={error} />

                    {/* Body */}
                    <div className="mx-auto max-w-lg mt-14">
                        {/* Login Details */}
                        <div className="w-full">
                            <div className="mt-4 flex flex-col gap-7 w-full">
                                <label htmlFor="firstname" className='space-y-2'>
                                    <p>Firstname <small className='text-red-500'>*</small></p>
                                    <Input id="firstname" onChange={handleInput} value={data.firstname} />
                                </label>
                                <label htmlFor="lastname" className='space-y-2'>
                                    <p>Lastname <small className='text-red-500'>*</small></p>
                                    <Input id="lastname" onChange={handleInput} value={data.lastname} />
                                </label>
                                <label htmlFor="email" className='space-y-2'>
                                    <p>Email <small className='text-red-500'>*</small></p>
                                    <Input id="email" onChange={handleInput} value={data.email} />
                                </label>
                                <label htmlFor="password" className='space-y-2'>
                                    <p>Phone Number <small className='text-red-500'>*</small></p>
                                    <div className="flex lg:items-center gap-5 lg:gap-2 flex-col lg:flex-row">
                                        <div className="w-full lg:w-5/12">
                                            <Select value={data?.code} onChange={(e) => setData({ ...data, code: e.target.value })}>
                                                <option value="">Select Country</option>
                                                {countriesData?.map((country, i) => (
                                                    <option value={country?.code} key={i}>{country?.name}</option>
                                                ))}
                                            </Select>
                                        </div>
                                        <Input placeholder="Phone Number" type="number" id="phone" value={data.phone} onChange={handleInput} />
                                    </div>
                                </label>
                                <label htmlFor="password" className='space-y-2'>
                                    <p>Password <small className='text-red-500'>*</small></p>
                                    <Input id="password" type='password' onChange={handleInput} value={data.password} />
                                </label>
                                <Button fullWidth loading={isPending} onClick={handleLogin}>Register</Button>
                                <LinkButton to='/account/login' fullWidth>Log In</LinkButton>
                            </div>
                        </div>

                    </div>
                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default Register